import React from "react";

import { Database } from "icons";
import { useParams } from "react-router-dom";

import { PageLoader } from "clearsense-ui/components";
import { EmptyState } from "components/Common";
import { humanize } from "utils/stringManipulations";

import Charts from "./Charts";
import DetailsAccordion from "./DetailsAccordion";

const Summary = ({
  isJobDetailsLoading,
  jobDetails,
  isOutputsLoading,
  outputs,
  setOutputs,
}) => {
  const { datasetName } = useParams();

  if (isJobDetailsLoading) {
    return <PageLoader />;
  } else if (!jobDetails) {
    return <EmptyState />;
  }

  return (
    <>
      <DetailsAccordion
        title={datasetName ? humanize(datasetName) : "Renal Failure CSV"}
        icon={<Database />}
        jobDetails={jobDetails}
      />

      {isOutputsLoading ? (
        <PageLoader />
      ) : (
        <Charts outputs={outputs} setOutputs={setOutputs} />
      )}
    </>
  );
};

export default Summary;
